module.exports = __webpack_public_path__ + "img/QDO_Placeholder-2.ed6c172a.png";